import { render, staticRenderFns } from "./MovieLike.vue?vue&type=template&id=770eb1bd&"
import script from "./MovieLike.vue?vue&type=script&lang=js&"
export * from "./MovieLike.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports